<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ isEditing ? 'Edit' : 'Add' }} Blog Category</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.blog-categories.index')">Blog Categories</Link>
                            </li>
                            <li class="breadcrumb-item active">{{ isEditing ? 'Edit' : 'Add' }} Blog Category</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="saveCategory">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input type="text" v-model="category.name" class="form-control" placeholder="Category name" required>
                                    <div v-if="category.errors.name" class="text-danger text-small">
                                        {{ category.errors.name }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="form-check mt-2">
                                        <input class="form-check-input" type="checkbox" v-model="category.status" :true-value="true" :false-value="false">
                                        <label class="form-check-label">Active</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1" :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";

export default {
    metaInfo: {title: 'Blog Category'},
    props: ['isEditing', 'categoryData'],
    components: { Link },
    layout: Layout,
    data() {
        return {
            category: this.$inertia.form({
                name: null,
                status: true,
            }),
            saving: false
        }
    },
    methods: {
        async saveCategory() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => this.saving = false
            };

            if (this.isEditing) {
                this.category.put(route('admin.blog-categories.update', this.categoryData.id), options);
            } else {
                this.category.post(route('admin.blog-categories.store'), options);
            }
        }
    },
    mounted() {
        if (this.isEditing) {
            this.category.name = this.categoryData.name;
            this.category.status = this.categoryData.status;
        }
    },
}
</script>
